function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg38(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.98 53.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.25,1.03c-1.9,1.35-2.85,1.41-5.86.42C1.7-1.41-3.04,8.58,2.17,18.79c1.18,2.32,3.63,8.62,5.45,14,3,8.9,7.15,16.07,11.27,19.46,2.13,1.75,4.14,1.56,4.14-.4,0-1.54.13-1.54,1.83,0,1.01.91,3.03,1.65,4.5,1.65,3.44,0,3.51-2.32.23-8.1-1.35-2.37-3-7.42-3.68-11.21-1.13-6.33-1.04-7.68,1.1-16.1,1.43-5.6,2.07-10.24,1.66-11.88-1.22-4.87-8.53-7.92-12.41-5.18",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.06,3.52c3.95,2.11,4.31,4.63,1.86,13.09l-2.28,7.89h-7.56s-7.56,0-7.56,0l-2.77-5.75C1.61,12.25,1.32,8.95,3.58,5.72c1.74-2.49,4.09-2.8,7.93-1.05,2.15.98,2.87.89,4.26-.5,1.91-1.91,4.51-2.14,7.29-.65",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,32.9c.51,4.88,2.2,9.58,6.4,17.85.21.41-.25.75-1.03.75-2.3,0-5.35-4.03-9.1-12-3.52-7.51-5.23-6.98-2.03.63,2.41,5.73,3.34,9.37,2.39,9.37-1.67,0-7.78-9.62-9.53-15-.98-3.02-1.94-5.95-2.14-6.5-.22-.61,2.54-1.01,7.03-1.01l7.39-.02.62,5.93",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg38);
export default __webpack_public_path__ + "static/media/38.f730ae4e89335fe6d62d4479cb5fe20c.svg";
export { ForwardRef as ReactComponent };